// CLI — `grid wire` command group: the unifying "bind A to B" verb.
//
// Per Decision 042 (Mode 1, §wire), `wire` is the one verb for binding the
// current folder/entity to an external thing:
//
//   wire folder <entity>        — bind this folder to an existing grid entity
//                                 (same core as the top-level `link` alias)
//   wire repo   [github-url]    — bind a GitHub repo for auto-deploy on push
//   wire hook   <url> [--event] — subscribe a webhook URL to this entity's events
//
// Deferred subcommands (spec §21): `wire inspire`, `wire agent-reads`.

import { Command } from 'commander';
import { wireRepoCommand } from './wire-repo.js';
import { makeWireFolderCommand } from './wire-folder.js';
import { makeWireHookCommand } from './wire-hook.js';

// ── Deferred subcommands (spec §21) ────────────────────────────────────────

const wireInspireCommand = new Command('inspire')
  .description('Bind an inspiration source (not yet supported)')
  .allowUnknownOption()
  .action(() => {
    process.stdout.write('grid wire inspire: not yet supported.\n');
    process.exit(0);
  });

const wireAgentReadsCommand = new Command('agent-reads')
  .description('Bind agent read sources (not yet supported)')
  .allowUnknownOption()
  .action(() => {
    process.stdout.write('grid wire agent-reads: not yet supported.\n');
    process.exit(0);
  });

// ── `wire` namespace ───────────────────────────────────────────────────────

export const wireCommand = new Command('wire')
  .description('Bind things together: a folder, a repo, or a webhook')
  .addCommand(makeWireFolderCommand('folder'))
  .addCommand(wireRepoCommand)
  .addCommand(makeWireHookCommand())
  .addCommand(wireInspireCommand)
  .addCommand(wireAgentReadsCommand);

/**
 * Register the `wire` command on the top-level Commander program.
 * Called from `index.ts`.
 */
export function registerWireCommand(program: Command): void {
  program.addCommand(wireCommand);
}
